// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"01afbeb4","233":"f2ebedbe"}[chunkId] + ".chunk.js";
};